import React, { useEffect } from "react";
import { Layout, Badge, Dropdown, Button } from "antd";
import { Link } from "react-router-dom";
import { DownOutlined } from "@ant-design/icons";
import { useIntercom } from "react-use-intercom";

import MainMenu from "../Menu/Main";
import { hexToHexA } from "../../utils/color";
import { getTranslation } from "../../utils/helper";

const { Header } = Layout;

const MainHeader = ({ user }) => {
  const roles = user?.roles || [];
  const company = user?.company || {};
  const backgroundOpacity = hexToHexA(company?.primaryColor, 0.24);
  const avatarBackground = backgroundOpacity?.replace("#", "");
  const avatarColor = company?.primaryColor?.replace("#", "");
  const { boot } = useIntercom();
  useEffect(() => {
    boot({
      name: user?.name,
      email: user?.email,
    });
  }, [user, boot]);

  const default_logo = `/logo-${
    window.location.origin.includes("nordicrouting.se") ? "nordicrouting" : "parcelizer"
  }.svg`;

  const menu = {
    items: [
      ...(roles.includes("company_admin") || roles.includes("admin")
        ? [
            {
              key: "message-logs",
              label: (
                <Link to="/message-logs" className="message-logs">
                  <Button type="text" size="small">
                    {getTranslation(company, "Menu", "Message Logs")}
                  </Button>
                </Link>
              ),
            },
          ]
        : []),
      {
        key: "logout",
        label: (
          <Link to="/logout" className="logout">
            <Button type="text" size="small">
              {getTranslation(company, "Menu", "Log Out")}
            </Button>
          </Link>
        ),
      },
    ],
  };

  return (
    <Header className="MainHeader" style={{ position: "fixed", zIndex: 9999, width: "100%" }}>
      <div className="logo">
        <Link to="/">
          <img src={`${company?.logo ? company?.logo : default_logo}`} alt="logo" />
        </Link>
      </div>
      {user && (
        <>
          <MainMenu user={user} />
          <div className="account-info">
            <Badge count={100} overflowCount={99} showZero />
            <div className="avatar">
              <img
                src={`https://ui-avatars.com/api/?length=1&name=${
                  user?.name || user?.email
                }&size=32&font-size=0.4&bold=true&background=${
                  avatarBackground || "9863f3"
                }&color=${avatarColor}&rounded=true`}
                alt=""
              />
            </div>
            <div className="info">
              <div className="fullname">{user?.name}</div>
              <Dropdown trigger={["click"]} menu={menu}>
                <div className="email">
                  {user?.email} <DownOutlined />
                </div>
              </Dropdown>
            </div>
          </div>
        </>
      )}
    </Header>
  );
};

export default MainHeader;
